import { styled } from '@mui/material';

export const StyledFieldRow = styled('div')`
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
`;
